import type { AuthenticatedUser, SystemRole } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

/**
 * Switches the session's active role — the server verifies the caller
 * currently holds it and re-issues both cookies, so the response body is the
 * fresh `/me` shape for a role the person actually holds, never a locally
 * narrowed guess.
 */
export const setActiveRole = async (role: SystemRole): Promise<AuthenticatedUser> => {
  const response = await apiClient.post<AuthenticatedUser>('/auth/role', { role });
  return response.data;
};
